import styled from 'styled-components'
import { Flex } from 'components'
import { colors as c } from 'utils'

export const ToastAction = styled(Flex)`
  &:hover {
    background: ${c('white', '10')};
  }
`
